import { css } from '@microsoft/fast-element'
import type { ElementStyles } from '@microsoft/fast-element'
import type { FoundationElementTemplate } from '@microsoft/fast-foundation'
import { asElementStyles, baseStyles, hostStyles } from '../../utils/styles'
import type { ProductUgcDefinitionOptions } from './product-ugc.element'

import ProductUgcStylesheet from './product-ugc.styles.scss'

const elementStyles = asElementStyles(ProductUgcStylesheet)

/**
 * Styles for the {@link ProductUgc} component.
 * @public
 */
export const ProductUgcStyles: FoundationElementTemplate<ElementStyles, ProductUgcDefinitionOptions> = (
  context,
  definition,
) => {
  // TODO: Use the definition options to conditionally add styles

  return css`
    ${hostStyles}
    ${baseStyles}
  ${elementStyles}
  `
}
